import React from 'react';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import _ from 'lodash';

export const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <TextField
      label={label}
      error={!!(touched && error)}
      helperText={touched && error}
      margin='normal'
      fullWidth
      {...input}
      {...custom}
    />
  );
}

export const renderNumberField = ({
  input, meta: { touched, error }, ...rest
}) => {
  return (
    <TextField
      {...input}
      {...rest}
      fullWidth
      margin='normal'
      type="number"
      error={!!(touched && error)}
      helperText={touched && error}
    />
  );
}

export const renderCurrencyField = ({
  input, meta: { touched, error }, ...rest
}) => {
  return (
    <TextField
      {...input}
      {...rest}
      fullWidth
      margin='normal'
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
      error={!!(touched && error)}
      helperText={touched && error}
    />
  );
}

export const requiredValidator = value => (value ? undefined : 'Required')

export const renderSelect = ({name, options, input, label}) => {
  return (
    <FormControl style={{display: 'flex'}} margin='normal'>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        inputProps={{
          name: name,
          id: name,
        }}
        {...input}
      >
        {options.map(option => <MenuItem key={`${name}-${option}`} value={option}>{_.startCase(option)}</MenuItem>)}
      </Select>
    </FormControl>
  );
}

const sanitizeInputValue = (input) => {
  if (!_.isUndefined(input.value)) {
    input['value'] = input.value.toString();
  }
  return input;
}

export const renderRadioGroup = ({name, input, options, label}) => {
  input =  sanitizeInputValue(input)
  return (
    <FormControl style={{display: 'flex'}}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label={name}
        name={name}
        {...input}
        style={{flexDirection: 'row'}}
      >
        {options.map(option => <FormControlLabel key={`${name}-${option.value}`} value={option.value.toString()} control={<Radio />} label={option.key} />)}
      </RadioGroup>
    </FormControl>
  );
}
const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});

const datePicker = (props) => {
  const { classes } = props;
  const formattedDate = moment(props.input.value).format('YYYY-MM-DD')
  return (
    <form className={classes.container} noValidate>
      <TextField
        {...props.input}
        id={props.input.name}
        label={props.label}
        type="date"
        fullWidth
        margin='normal'
        value={formattedDate}
      />
    </form>
  );
}

export const renderDatePicker = withStyles(styles)(datePicker);

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(_, e) => {onChange(e)}}
      thousandSeparator
      prefix="$"
    />
  );
}



// WEBPACK FOOTER //
// ./src/utils/formHelper.js